import { apolloProvider } from "@/main";
const { defaultClient: Moon } = apolloProvider;
import {
  queryGetDetailUserGroupSysByName,
  mutationRemoveUserFromUserGroupSys,
  queryGetUsers,
  mutationAddMoreUsersToUserGroupSys,
} from "./query.define";

export const getDetailUserGroupSysByName = (name) => {
  return Moon.query({
    query: queryGetDetailUserGroupSysByName,
    variables: { name },
  });
};

export const getUsers = (variables) => {
  return Moon.query({
    query: queryGetUsers,
    variables,
  });
};

export const removeUserFromUserGroupSys = (variables) => {
  return Moon.mutate({
    mutation: mutationRemoveUserFromUserGroupSys,
    variables,
  });
};

export const addMoreUsersToUserGroupSys = (variables) => {
  return Moon.mutate({
    mutation: mutationAddMoreUsersToUserGroupSys,
    variables,
  });
};
